import { render, staticRenderFns } from "./JdsRichDropdown.vue?vue&type=template&id=a7c6b4f6&scoped=true&"
import script from "./JdsRichDropdown.vue?vue&type=script&lang=ts&"
export * from "./JdsRichDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./JdsRichDropdown.vue?vue&type=style&index=0&id=a7c6b4f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c6b4f6",
  null
  
)

export default component.exports